import { Button } from '@/shared/components/ui/button';
import { CardContent } from '@/shared/components/ui/card';
import { useTranslation } from 'react-i18next';
import { Input } from '@/shared/components/ui/input';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/shared/components/ui/form';
import { usePasswordRecoveryForm } from '@/features/auth-login';
import { AuthCard } from '@/shared/components';

type Props = {
  className?: string;
};

const LoginPasswordRecoveryForm = ({ className }: Props) => {
  const { t } = useTranslation();
  const { form, submitHandler } = usePasswordRecoveryForm();

  return (
    <AuthCard
      className={className}
      title={t('authPages.passwordRecoveryForm.title')}
      description={t('authPages.passwordRecoveryForm.description')}
      backButton={{ link: '/login' }}
      titleClassName="items-start flex-wrap">
      <CardContent className="p-0">
        <Form {...form}>
          <form
            className="space-y-10"
            noValidate
            onSubmit={form.handleSubmit(submitHandler)}>
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem className="mb-[3.2rem]">
                  <FormControl>
                    <Input
                      {...field}
                      type="email"
                      label={t(
                        'authPages.passwordRecoveryForm.emailInputPlaceholder'
                      )}
                      className="p3"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}></FormField>
            <Button type="submit" size="lg">
              {t('authPages.passwordRecoveryForm.submitButton')}
            </Button>
          </form>
        </Form>
      </CardContent>
    </AuthCard>
  );
};

export { LoginPasswordRecoveryForm };
